import {Injectable} from '@angular/core';
import {LocalizeRouterService} from "@gilsdav/ngx-translate-router";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class CustomRouterService {

  constructor(private readonly localizeRouterService: LocalizeRouterService, private readonly translateService: TranslateService, private readonly router: Router,) {
  }

  /** Avoid `//home` or broken navigation when TranslateService has not resolved `currentLang` yet (e.g. right after login). */
  private currentLangSegment(): string {
    const raw = (this.translateService.currentLang || this.translateService.getDefaultLang() || 'en').toString().trim();
    return raw.toLowerCase() || 'en';
  }

  goToPage(path: string, options?: any) {
    const translated = <string>this.localizeRouterService.translateRoute(this.formatPath(path));
    void this.router.navigateByUrl(`${this.currentLangSegment()}/${translated}`, options || {});
  }

  getRoutePathTranslated(path: string) {
    return `${this.currentLangSegment()}/${<string>this.localizeRouterService.translateRoute(this.formatPath(path))}`;
  }

  formatPath(path: string) {
    return path.startsWith("/") ? path.substring(1) : path;
  }

}
